// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__3XvjC","head":"ProcedureTableInfo_head__3cQfZ"};